import { render, staticRenderFns } from "./RootPage.vue?vue&type=template&id=18fa5176&scoped=true&"
import script from "./RootPage.vue?vue&type=script&lang=js&"
export * from "./RootPage.vue?vue&type=script&lang=js&"
import style0 from "./RootPage.vue?vue&type=style&index=0&id=18fa5176&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fa5176",
  null
  
)

export default component.exports